import { Component, ElementRef, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { UntypedFormControl, Validators } from "@angular/forms"
import { Subscription } from "rxjs"
import { debounceTime } from "rxjs/operators"
import { Porteur } from "../shared/porteur"
import { PorteurService } from "../shared/porteur.service"

@Component({
  selector: 'app-porteur-list',
  templateUrl: './porteur-list.component.html',
  styleUrls: ['./porteur-list.component.scss']
})
export class PorteurListComponent implements OnInit, OnDestroy {
  @HostBinding('class.clamp') clamp = true

  porteurs: Array<Porteur> = new Array<Porteur>()
  input_hint: String
  load: Subscription = new Subscription()
  filter
  inputControl: UntypedFormControl = new UntypedFormControl('', [
    Validators.required
  ])
  radioControl: UntypedFormControl = new UntypedFormControl('nom')
  labelSiVide: String
  breakpoint: number

  previousValue = this.radioControl.value;

  @ViewChild('filter', { static: true }) searchElement: ElementRef

  constructor(private porteurService: PorteurService) {
    this.radioControl.valueChanges.subscribe(value => this.porteurs = this.sort(this.porteurs))
  }

  ngOnDestroy() {
    this.load.unsubscribe()
  }


  private sort(array: Array<Porteur>): Array<Porteur> {
    return array.sort((a: Porteur, b: Porteur) => {
      if (this.radioControl.value) {
        if (Number(a.numPorteur) < Number(b.numPorteur)) return -1
        else return 1
      } else {
        if (a.porteur < b.porteur) return -1
        else return 1
      }
    })
  }

  private searchPorteurs() {
    this.load.unsubscribe()
    this.load = this.porteurService.getPorteurs(this.inputControl.value, this.radioControl.value).subscribe(
      porteurs => {
        this.porteurs = this.sort(porteurs)
        if (this.porteurs.length == 0) {
          this.labelSiVide = 'Aucun résultat'
        }
      })
  }

  ngOnInit() {
    this.onResize(window.innerWidth)

    this.labelSiVide = 'Veuillez effectuer votre recherche'
    this.searchElement.nativeElement.focus()
    this.inputControl.markAsTouched({ onlySelf: true })
    this.inputControl.valueChanges.pipe(
      debounceTime(500))
      .subscribe(value => {
        if (value.length > 2 && this.radioControl.value == "nom") {
          this.searchPorteurs()
          this.labelSiVide = ''
        } else if (value.length > 0 && (this.radioControl.value == "casier" || this.radioControl.value == "porteur")) {
          this.searchPorteurs()
          this.labelSiVide = ''
        } else {
          this.porteurs = new Array<Porteur>()
        }
      })

    this.radioControl.valueChanges.subscribe(value => {
      // Permettre de garder si des valeurs numériques renseignées mais pas le bon filtre
      if (this.previousValue !== 'porteur' && value === 'porteur' && !Number(this.inputControl.value)) {
        this.inputControl.reset();
      }
      this.previousValue = value;

      this.porteurs = new Array<Porteur>()
    })
  }


  minLength() {
    if (this.radioControl.value == "nom") {
      return 3
    } else {
      return 0
    }
  }

  onResize(event) {
    const x = event
    switch (true) {
      case (x <= 768):
        this.breakpoint = 1
        break
      case (x >= 768 && x <= 1200):
        this.breakpoint = 2
        break
      case (x >= 1200 && x <= 1400):
        this.breakpoint = 3
        break
      case (x > 1400):
        this.breakpoint = 4
        break
      default:
        this.breakpoint = 4
        break
    }
  }

  onKeyPress(event: KeyboardEvent) {
    // Quand on recherche par porteur, autoriser uniquement les chiffres (0-9)
    if (this.radioControl.value === 'porteur' && !/^\d$/.test(event.key)) {
        event.preventDefault();
    }
  }
}
